import { action, flow, makeObservable, observable } from 'mobx';
import { ShareKnowledgeApi } from '../apis';
import BaseStore from './BaseStore';

class ShareKnowledgeStore extends BaseStore {
    lstFile = {};
    fileSearchParams = {};
    groupInfo = {};
    lstRequest = [];
    pagingLstRequest = {
        ...this.paging,
        page: 1,
        size: 20
    };
    lstFileShareknowledge = [];
    pagingLstFileShareknowledge = {
        ...this.paging,
        page: 1,
        size: 20
    };
    lstViewer = {};

    constructor(rootStore) {
        super();
        makeObservable(this, {
            lstFile: observable,
            lstRequest: observable,
            pagingLstRequest: observable,
            lstFileShareknowledge: observable,
            pagingLstFileShareknowledge: observable,
            lstViewer: observable,
            getGroupInfo: flow.bound,
            getFilesGroup: flow.bound,
            getAllRequestForGA: flow.bound,
            getAllFileShareknowledge: flow.bound,
            getPresignedUrlsDonwload: flow.bound,
            clearLstRequest: action.bound,
            clearLstFileShareknowledge: action.bound,
            updateLocalViewStatus: action.bound,
            fileSearchParams: observable,
            setFileSearchParams: flow.bound,
            createFile: flow.bound,
            updateFile: flow.bound,
            deleteFile: flow.bound,
            getFileInfo: flow.bound,
            getPresignedUrls: flow.bound,
            viewFileProgress: flow.bound,
            getFileViewers: flow.bound,
            exportFileViewersCsv: flow.bound
        });
        this.rootStore = rootStore;
        this.api = new ShareKnowledgeApi();
    }

    *getFilesGroup(searchParams) {
        try {
            const res = yield this.rootStore.apiStore.call(
                this.api,
                this.api.getFilesGroup,
                searchParams
            );
            if (res?.ok) {
                return res?.data;
            }
            return false;
        } catch (error) {
            console.log(error);
        }
    }
    setFileSearchParams(payload) {
        this.fileSearchParams = payload;
    }
    *getGroupInfo() {
        try {
            const res = yield this.rootStore.apiStore.call(
                this.api,
                this.api.getGroupInfo
            );
            if (res?.ok) {
                this.groupInfo = res?.data;
            }
            return false;
        } catch (error) {
            console.log(error);
        }
    }

    *createFile(payload) {
        try {
            const res = yield this.rootStore.apiStore.call(
                this.api,
                this.api.createFile,
                payload
            );
            if (res?.ok) {
                return res?.data;
            }
            return false;
        } catch (error) {
            console.log(error);
        }
    }
    *updateFile(payload) {
        try {
            const res = yield this.rootStore.apiStore.call(
                this.api,
                this.api.updateFile,
                payload
            );
            if (res?.ok) {
                return true;
            }
            return false;
        } catch (error) {
            console.log(error);
            return error;
        }
    }
    *deleteFile(payload) {
        try {
            const res = yield this.rootStore.apiStore.call(
                this.api,
                this.api.deleteFile,
                payload
            );
            if (res?.ok) {
                return res?.data;
            }
            return false;
        } catch (error) {
            console.log(error);
        }
    }
    *getFileInfo(payload) {
        try {
            const res = yield this.rootStore.apiStore.call(
                this.api,
                this.api.getFileInfo,
                payload
            );

            if (res?.ok) {
                return res?.data;
            }
            return false;
        } catch (error) {
            console.log(error);
        }
    }


    *getAllRequestForGA(searchParams) {
        try {
            const { size, page, sortDir, sortKey } = this.pagingLstRequest;
            const payload = { size, page, sortDir, sortKey, ...searchParams };
            const res = yield this.rootStore.apiStore.call(
                this.api,
                this.api.getAllRequestForGA,
                payload
            );
            if (res?.ok) {
                this.lstRequest = res?.data?.elements;
                this.pagingLstRequest = res?.data?.paginate;
            }
        } catch (error) {
            console.log(error);
        }
    }
    *getAllFileShareknowledge(searchParams, isHideLoading = false) {
        try {
            let sortKey, sortDir;
            const { sortBy, ...rest } = searchParams;
            const { size, page } = this.pagingLstFileShareknowledge;
            if (sortBy) {
                sortKey = 'created_at';
                sortDir = sortBy;
            }
            const payload = { size, page, sortDir, sortKey, ...rest };
            const res = yield this.rootStore.apiStore.call(
                this.api,
                this.api.getAllFileShareknowledge,
                payload,
                false,
                null,
                isHideLoading
            );
            if (res?.ok) {
                this.lstFileShareknowledge = res?.data?.elements;
                if (!searchParams?.isHomePage) {
                    this.pagingLstFileShareknowledge = res?.data?.paginate;
                }
            }
        } catch (error) {
            console.log(error);
        }
    }

    *getPresignedUrlsDonwload(payload) {
        try {
            const res = yield this.rootStore.apiStore.call(
                this.api,
                this.api.getPresignedUrlsDonwload,
                payload
            );
            if (res?.ok) {
                return res.data;
            }
            return false;
        } catch (error) {
            console.log(error);
        }
    }
    *getPresignedUrls(payload) {
        try {
            const res = yield this.rootStore.apiStore.call(
                this.api,
                this.api.getPresignedUrls,
                payload
            );
            if (res?.ok) {
                return res.data;
            }
            return false;
        } catch (error) {
            console.log(error);
        }
    }

    *viewFileProgress(id, payload, disableLoading = true) {
        try {
            const res = yield this.rootStore.apiStore.call(
                this.api,
                this.api.viewFileProgress,
                [id, payload], false, null, disableLoading
            );
            if (res?.ok) {
                // Returns the server-computed view status ({ viewStatus }) so callers reflect the DB truth.
                return res?.data;
            }
            return false;
        } catch (error) {
            console.log(error);
        }
    }

    clearLstRequest() {
        this.lstRequest = [];
        this.pagingLstRequest = {
            ...this.paging,
            page: 1,
            size: 20
        };
    }

    clearLstFileShareknowledge() {
        this.lstFileShareknowledge = [];
        this.pagingLstFileShareknowledge = {
            ...this.paging,
            page: 1,
            size: 20
        };
    }

    // Refresh a file's view status badge in place (no list refetch, #17678).
    // View status only moves forward, so never downgrade (e.g. a heartbeat must not undo a completed view).
    updateLocalViewStatus(fileId, viewStatus) {
        this.lstFileShareknowledge = this.lstFileShareknowledge.map((file) =>
            file.id === fileId
                ? { ...file, viewStatus: Math.max(file.viewStatus || 0, viewStatus) }
                : file
        );
    }

    *getFileViewers(fileId, searchParams) {
        try {
            const res = yield this.rootStore.apiStore.call(
                this.api,
                this.api.getFileViewers,
                [fileId, searchParams]
            );
            if (res?.ok) {
                this.lstViewer = res?.data;
                return res?.data;
            }
            return false;
        } catch (error) {
            console.log(error);
        }
    }

    *exportFileViewersCsv(fileId, searchParams) {
        try {
            const res = yield this.rootStore.apiStore.call(
                this.api,
                this.api.exportFileViewersCsv,
                [fileId, searchParams]
            );
            return res;
        } catch (error) {
            console.log(error);
        }
    }
}

export default ShareKnowledgeStore;
